export const LOCATION_API_PATHS = {
  search: '/locations/search',
  reverse: '/locations/reverse',
} as const

export const LOCATION_STORAGE_KEY = 'maaliondoor.delivery-location.v2'

/** Set once checkout starts, so the delivery area cannot change mid-order. */
export const LOCATION_LOCK_STORAGE_KEY = 'maaliondoor.checkout-location-lock'

export type DeliveryLocation = {
  /** Human-readable area / locality from geolocation or search. */
  label: string
  city: string
  pincode?: string
  lat?: number
  lng?: number
}

export type LocationSuggestion = {
  label: string
  city: string
  pincode?: string | null
  lat: number
  lng: number
}

export const PINCODE_LENGTH = 6

/** Debounce for typeahead search against the backend locations API. */
export const GEOCODE = {
  searchLimit: 7,
  searchDebounceMs: 350,
} as const

export const LOCATION_MODAL = {
  title: 'Enter delivery location',
  subtitle: '60-min delivery now live in some areas',
  searchLabel: 'Search for area / locality*',
  searchPlaceholder: 'Start typing your area',
  useCurrent: 'Use my current location',
  detecting: 'Detecting…',
  searching: 'Searching…',
  changeAria: 'Change delivery location',
  selectLabel: 'Select location',
  deliverTo: 'Deliver to',
  closeAria: 'Close',
  dialogLabel: 'Delivery location',
  clearSearch: 'Clear search',
  noResults: 'No matches found. Try a different area, or use current location.',
  searchFailed:
    'Location search is unavailable right now. Try again, or use current location.',
} as const

export const LOCATION_DETECT_ERRORS = {
  unsupported: 'Location is not supported in this browser. Search for an area instead.',
  denied: 'Location permission denied. Search for an area instead.',
  unavailable: 'Could not detect your location. Search for an area instead.',
  outOfRange: 'You’re outside our delivery cities. Search for an area instead.',
  geocodeFailed: 'Could not resolve your address. Search for an area instead.',
} as const
